<template>
    <div class="d-flex">
        <svg-icon class="ml-2 mt-1" :svgData="svgData"/>
        <div class="ml-3">
            <div class="text-left">
                <a class="personalities-file-name" :href="href" target="_blank">{{text}}</a>
            </div>
        </div>
    </div>
</template>
<script>

import SvgIcon from '@/components/content/SvgIcon.vue'

export default{
    name: 'PersonalitiesFile',
    components: {
        SvgIcon
    },
    props: ['href','text'],
    data () {
            return {
                open: true,
                svgData: {
                    width: "48",
                    height: "60",
                    viewBox: "0 0 48 60",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    pathArr: [{
                        d: "M6.50033 0.833496H29.8337L47.3337 18.3335V53.3335C47.3337 56.5418 44.7087 59.1668 41.5003 59.1668H6.47116C3.26283 59.1668 0.666992 56.5418 0.666992 53.3335V6.66683C0.666992 3.4585 3.29199 0.833496 6.50033 0.833496ZM12.3337 47.5002H35.667V41.6668H12.3337V47.5002ZM35.667 35.8335H12.3337V30.0002H35.667V35.8335ZM26.917 5.2085V21.2502H42.9587L26.917 5.2085Z",
                        fill: "#3B66D3"
            }]
        }
      }
    }
}
</script>